import { decamelizeKeys } from 'xcase';

import axios from '../../localAxios';
import { WorkspaceSettings } from '../types';
import { workspaceSettingsURL } from '../workspacesURLs';

interface PatchWorkspaceSettingsParams {
  workspaceId: string;
  patch: Partial<WorkspaceSettings>;
}

export async function patchWorkspaceSettings({
  workspaceId,
  patch,
}: PatchWorkspaceSettingsParams) {
  const url = workspaceSettingsURL(workspaceId);
  // FE keeps camelCase end-to-end (response interceptor camelizes); BE Joi
  // validator expects snake_case, so we decamelize on the way out. Matches
  // the pattern in `importWorkspaceQuizBySoc.ts` and `addBulkQuestions.ts`.
  //
  // PUT (not PATCH) — the teacher service's CORS `allowedMethods` doesn't
  // include PATCH. Server still merges the body as a partial delta.
  const response = await axios.put<WorkspaceSettings>(
    url.href,
    decamelizeKeys(patch)
  );
  return response.data;
}
